// extracted by mini-css-extract-plugin
export default {"container":"LoadingSpinner_container__jfbGH","spinner":"LoadingSpinner_spinner__rYin+","spin":"LoadingSpinner_spin__N196u"};